import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let MaintenanceApiPromise: Promise<AxiosInstance> | null = null;

const getMaintenanceApi = async (): Promise<AxiosInstance | null> => {
  if (MaintenanceApiPromise) return MaintenanceApiPromise;
  MaintenanceApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return MaintenanceApiPromise;
};

export const getMantenimiento = async () => {
  const api = await getMaintenanceApi();

  if (!api) return;

  const response = await api.get("/Mantenimiento");

  return response.data;
};

export interface PatchMantenimientoProps {
  codigoModulo: string;
  codigoSeccion: string;
  nuevoEstado: boolean;
}

export const patchMantenimiento = async (props: PatchMantenimientoProps) => {
  const api = await getMaintenanceApi();

  if (!api) return;

  const response = await api.patch(
    `/Mantenimiento?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
}